var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c(
          "DxPivotGrid",
          {
            attrs: {
              id: "saldos",
              "allow-sorting-by-summary": true,
              "allow-sorting": true,
              "allow-filtering": true,
              "row-header-layout": _vm.rowHeaderLayout,
              "show-borders": true,
              "data-source": _vm.dataSource,
              "show-column-grand-totals": false,
              texts: _vm.texts,
              "on-cell-prepared": _vm.onCellPrepared,
              "hide-empty-summary-cells": _vm.hideEmptySummaryCells,
            },
          },
          [
            _c("DxFieldChooser", {
              attrs: { height: 500, texts: _vm.texts, title: _vm.displayTitle },
            }),
            _vm._v(" "),
            _c("DxExport", { attrs: { enabled: true } }),
            _vm._v(" "),
            _c("DxFieldPanel", {
              attrs: {
                "show-column-fields": _vm.showColumnFields,
                "show-data-fields": _vm.showDataFields,
                "show-filter-fields": _vm.showFilterFields,
                "show-row-fields": _vm.showRowFields,
                "allow-field-dragging": true,
                visible: true,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c(
          "span",
          { staticClass: "caption-subject font-green-sharp bold uppercase" },
          [_vm._v("\n        Saldos\n      ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }